export const SUBSCRIPTION_OPTIONS = {
  DEFAULT: 1,
  HOSTING: 2,
  VIDEO: 3,
  DEMO: 4,
}
